<script setup>
// Stopka strony wyników: logotypy partnerów wydarzenia (sledz-api event_sponsors, `sponsors`
// w /events/alias) i „Pomiar czasu i śledzenie GPS: ŚledźGPS”. Bez partnerów — sama ta linia.
import { computed, defineProps, reactive } from 'vue'
import { SLEDZGPS_HOME_URL } from '../../config.js'
import { normalizePartners } from '../../utils/event-info.js'

const props = defineProps({
  sponsors: { type: Array, default: () => [] },
  updatedAt: { type: String, default: '' }
})

const failed = reactive({})
const partners = computed(() => normalizePartners(props.sponsors).filter(p => !failed[p.key]))
const logo = `${process.env.BASE_URL || '/'}favicon.svg`
</script>

<template>
  <footer class="pf">
    <div class="pf__inner">
      <template v-if="partners.length">
        <h2 class="pf__title">Partnerzy wydarzenia</h2>
        <ul class="pf__list">
          <li v-for="p in partners" :key="p.key">
            <component
              :is="p.href ? 'a' : 'span'"
              class="pf__tile"
              :href="p.href || undefined"
              :target="p.href ? '_blank' : undefined"
              :rel="p.href ? 'noopener sponsored' : undefined"
              :title="p.name || undefined"
            >
              <img :src="p.src" :alt="p.name || 'Partner wydarzenia'" loading="lazy" @error="failed[p.key] = true" />
            </component>
          </li>
        </ul>
      </template>
      <div class="pf__system" :class="{ 'pf__system--alone': !partners.length }">
        <span>Pomiar czasu i śledzenie GPS:</span>
        <a :href="SLEDZGPS_HOME_URL" class="pf__brand" target="_blank" rel="noopener">
          <img :src="logo" alt="" width="20" height="20" />ŚledźGPS
        </a>
        <span class="pf__spacer" />
        <span v-if="updatedAt" class="pf__updated">Aktualizacja: {{ updatedAt }}</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.pf {
  background: var(--sledz-surface);
  border-top: 1px solid var(--sledz-border-soft);
}
.pf__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 26px 24px 22px;
}
.pf__title {
  margin: 0 0 14px;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--sledz-text-muted);
}
.pf__list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.pf__tile {
  width: 168px;
  height: 72px;
  padding: 8px 12px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid var(--sledz-border-soft);
  display: flex;
  align-items: center;
  justify-content: center;
}
a.pf__tile:hover {
  border-color: var(--sledz-border);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}
.pf__tile img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.pf__system {
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid var(--sledz-border-soft);
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--sledz-text-muted);
}
.pf__system--alone {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.pf__brand {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 800;
  color: var(--sledz-text);
  text-decoration: none;
}
.pf__brand img {
  border-radius: 5px;
}
.pf__spacer {
  flex: 1;
}
@media (max-width: 767.98px) {
  .pf__inner {
    padding: 22px 16px 26px;
  }
  .pf__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .pf__tile {
    width: 100%;
    height: 64px;
  }
  .pf__updated {
    display: none;
  }
}
</style>
